import Column from '@components/column'
import Row from '@components/row'
import CardHeading from '@commons/headings/card'
import Circle from '@components/circle'
import Typography from '@components/typography'
import Search from '@commons/search'
import Empty from '@commons/empty'
import { User } from '@apis'
import { useSelector } from 'react-redux'
import PatientCardLoader from '@commons/cards/patient/loader'
import PatientCard from '@commons/cards/patient'
import { StyleGrid } from './style'
import { Fragment, useEffect, useState } from 'react'
const DoctorPatientsPage = () => {
  const {
    items: patients,
    loading,
    totalItems,
  } = useSelector((state: any) => state.patients)
  const [params, setParams] = useState({
    page: 1,
    limit: 12,
    search: '',
  })
  const fetchData = async (params, action = 'set') => {
    await User.patients({
      action: action,
      params,
    }).catch(() => {})
  }

  useEffect(() => {
    if (!patients?.length) {
      fetchData(params)
    }
  }, [])
  return (
    <Column rowGap={20}>
      <Row justifyContent="space-between" alignItems="center">
        <CardHeading
          title="My Patients"
          titleRightComponent={
            <Circle bg="secondary" size={20}>
              <Typography content={totalItems} size={10} tc="white" />
            </Circle>
          }
        />
        <Search
          onSubmit={async (search) => {
            const updateParams = {
              ...params,
              page: 1,
              limit: 12,
              search,
            }
            await fetchData(updateParams)
            setParams(updateParams)
          }}
        />
      </Row>
      {!!loading ? (
        <StyleGrid>
          {Array(6)
            .fill(0)
            ?.map((_, index: number) => {
              return <PatientCardLoader key={index} />
            })}
        </StyleGrid>
      ) : (
        <>
          {!!patients?.length ? (
            <StyleGrid>
              {patients?.map((patient: any) => {
                return (
                  <Fragment key={patient?.id}>
                    <PatientCard patient={patient} />
                  </Fragment>
                )
              })}
            </StyleGrid>
          ) : (
            <Empty />
          )}
        </>
      )}
    </Column>
  )
}

export default DoctorPatientsPage
